import { ContextMembership, Cohort, Tunnel } from "./index";
import { GetMembersRequest } from "./msg-get-members-req";
import { GetMembersResponse, isGetMembersResponse } from "./msg-get-members-res";
import { generateCorrelationId, isCorrelated } from "./tunnel-message-data";

/**
 * @hidden
 */
export class TunnelOrganization implements Cohort {
    constructor(private readonly tunnel: Tunnel) {
    }
    getMembers(): Promise<ContextMembership> {
        return new Promise<ContextMembership>((resolve, reject) => {
            const id = generateCorrelationId();
            const subscription = this.tunnel.subscribe(function (message: MessageEvent<GetMembersResponse>) {
                if (isGetMembersResponse(message)) {
                    const response = message.data;
                    if (isCorrelated(response, id)) {
                        if (!response.err) {
                            resolve(response.value);
                        } else {
                            reject(response.err);
                        }
                        subscription.dispose();
                    }
                }
            });
            this.tunnel.postMessage<GetMembersRequest>({ type: '@stemcstudio/organization:get-members', id });
        });
    }
}
